import React, { useCallback } from 'react';
import { Box, Button, ButtonGroup, Typography } from '@mui/material';
import { ChartTimeline, ChartBarHorizontal } from '@opengov/react-capital-assets'
import { Switch } from '@opengov/component-library/capital';
import { styles } from './ProgressTracker.styles';
import { TimelineChartOrientation } from '@opengov/stories-shared/types';

interface PreviewSwitchProps {
	showPreview: boolean;
	onToggle: () => void;
	onOrientationChange: (orientation: TimelineChartOrientation) => void;
	label: string;
	orientationLabel: string;
	disabled?: boolean;
	orientation: TimelineChartOrientation;
}

export const PreviewSwitch = React.memo(({
	showPreview,
	onToggle,
	label,
	orientationLabel,
	disabled = false,
	orientation = TimelineChartOrientation.HORIZONTAL,
	onOrientationChange
}: PreviewSwitchProps) => {
	const handleToggle = useCallback(() => {
		if (disabled) return;
		onToggle();
	}, [onToggle, disabled]);

	const handleOrientationChange = (orientation: TimelineChartOrientation) => {
		onOrientationChange(orientation);
	}

	return (
		<Box sx={styles.previewToggleContainer}>
			{!showPreview ? <Box sx={styles.orientationToggleContainer}>
				<Typography variant="body2">
					{orientationLabel}
				</Typography>
				<ButtonGroup
					variant="contained"
					color="primary"
					size="small"
					aria-label="button group"
				>
					<Button
						color="primary"
						startIcon={<ChartTimeline />}
						variant={orientation === TimelineChartOrientation.VERTICAL ? "outlined" : "contained"}
						onClick={() => handleOrientationChange(TimelineChartOrientation.HORIZONTAL)}
					>
					</Button>
					<Button
						color="primary"
						startIcon={<ChartBarHorizontal />}
						variant={orientation === TimelineChartOrientation.VERTICAL ? "contained" : "outlined"}
						onClick={() => handleOrientationChange(TimelineChartOrientation.VERTICAL)}
					></Button>
				</ButtonGroup>
			</Box> : null}
			<Box sx={styles.previewSwitchContainer}>
				<Typography variant="body2">
					{label}
				</Typography>
				<Switch.Small
					checked={showPreview}
					onChange={handleToggle}
					labelOn=""
					labelOff=""
					disabled={disabled}
				/>
			</Box>
		</Box>
	);
});

PreviewSwitch.displayName = 'PreviewSwitch'; 